/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { List, ListItem, TableCell } from '@mui/material';
import { TableWidgetV2 } from '../../../components/v2';

const AuditTab = ({ auditMessages }) => {
  const getMessage = (message) => {
    if (message) {
      return (
        <List sx={{ p: 0 }}>
          {message.split('-').map((field, i) => (
            <ListItem key={i} sx={{ p: 0 }}>{i === 0 ? '' : '-'}{field}</ListItem>
          ))}
        </List>
      );
    }

    return message;
  };

  const renderRows = (d) => (
    <>
      <TableCell size="small">{d.timestamp}</TableCell>
      <TableCell size="small">{d.username}</TableCell>
      <TableCell>{getMessage(d.message)}</TableCell>
    </>
  );

  return (
    <TableWidgetV2
      bare
      titles={[
        'Data Modificação',
        'Usuário',
        'Descrição',
      ]}
      hasAdd={false}
      renderRows={renderRows}
      hasRowActions={false}
      rows={auditMessages || []}
    />
  );
};

AuditTab.propTypes = {
  auditMessages: PropTypes.array,
};

export default withRouter(AuditTab);
